



























































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Contacts from './Contacts.vue';
import NavFooter from './NavFooter.vue';
import FollowUs from './FollowUs.vue';
import PaymentLogos from './PaymentLogos.vue';
import Logo from '@/components/Logo';
import {mapGetters} from 'vuex';

@Component({
  name: 'AppFooter',
  components: {
    Contacts, NavFooter, FollowUs, PaymentLogos, Logo,
  },
  computed: {
    ...mapGetters([
      'phoneNumber',
      'email',
      'navigation',
      'followUs',
      'footerState',
      'translations',
    ]),
    ...mapGetters('user', ['logged']),
    actualFollowLinks() {
      const result = {};
      for (const key in (this as any).followUs) {
        if ((this as any).followUs[key]) {
          result[key] = (this as any).followUs[key];
        }
      }
      return result;
    },
    filteredNavigationRow() {
      return this.navigation && this.navigation.filter((item) => {
        return this.navigationConfigRow.some((name) => name === item.name);
      });
    },
    loginTitle() {
      for (const navItem of this.navigation) {
        if (navItem.name === 'accounts' && navItem.children) {
          for (const accountItems of navItem.children) {
            if (accountItems.name === 'login') {
              return accountItems.meta?.link_name;
            }
          }
        }
      }
    },
    newsTitle() {
      for (const navItem of this.navigation) {
        if (navItem.name === 'news') {
          return navItem.meta?.link_name;
        }
      }
    },
    businessTitle() {
      for (const navItem of this.navigation) {
        if (navItem.name === 'toBusiness') {
          return navItem.meta?.link_name;
        }
      }
    },
    profileTitle() {
      for (const navItem of this.navigation) {
        if (navItem.name === 'profile') {
          return navItem.meta?.link_name;
        }
      }
    },
  },
  data() {
    return {
      navigationConfigRow: [
        'about', 'toRenters',
      ],
      filtered: [],
    };
  },
  methods: {
    openInNewTab(url) {
      window.open(url);
    },
    resolvePermission(link) {
      return link?.meta?.hasPermission ?? true;
    },
    find(name) {
      return this.navigation.find((route) => {
        return route.name === name;
      });
    },
    resolveRoutePermission(name) {
      const route = this.find(name);
      return route?.meta?.hasPermission ?? true;
    },
  },
})
export default class AppFooter extends Vue {
}
